import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { Icon } from 'components/project/ClerkScreen';
import styled, { css } from 'styled-components';

import { breakpoints } from '../../../../shared/utils/styles';

export const PopoutComments = () => {
  const {
    BidStore: { auction: { auctioneerOpenPrivateNotes, auctioneerOpenPublicComments } },
    UIStore: { handleClosePopoutComments },
  } = useStores();

  return (
    <CommentContainer isPrivateNote={auctioneerOpenPrivateNotes.show}>
      <div>
        <div>{auctioneerOpenPrivateNotes.show ? 'Private Notes:' : 'Public Comments:'}</div>
        <div>
          <Icon
            icon="times-circle-o"
            size={2}
            onClick={() => handleClosePopoutComments()}
          />
        </div>
      </div>
      <div>
        {auctioneerOpenPrivateNotes.show && auctioneerOpenPrivateNotes.message}
        {auctioneerOpenPublicComments.show && auctioneerOpenPublicComments.message}
      </div>
    </CommentContainer>
  );
};

export default observer(PopoutComments);

export const CommentContainer = styled.div`
  ${({ isPrivateNote }) => css`
    grid-area: popoutComments;
    background-color: ${isPrivateNote ? '#DFEBE2' : '#A6B9AA'};
    min-width: 100%;
    padding: 20px 10px;
    height: minmax(800px, 100%);
    font-size: 2em;
    @media (max-width: ${breakpoints.auctioneer.small}) {
        font-size: 1.2em;
    }
    box-sizing: border-box;
    
    > div:first-child {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      font-size: 1.1em;
      font-weight: bold;
    }
    > div:last-child 
      height: 325px;
      @media (max-width: ${breakpoints.auctioneer.small}) {
        height: 210px;
      }
      overflow-y: auto;
    }
    & i {
      @media (max-width: ${breakpoints.auctioneer.small}) {
        font-size: 1.5em;
      }
    }
    & i:hover{
      cursor: pointer;
    }
  `};
`;
